import { render, staticRenderFns } from "./PromoBox.vue?vue&type=template&id=a0854b74&scoped=true&"
import script from "./PromoBox.vue?vue&type=script&lang=js&"
export * from "./PromoBox.vue?vue&type=script&lang=js&"
import style0 from "./PromoBox.vue?vue&type=style&index=0&id=a0854b74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0854b74",
  null
  
)

export default component.exports